import { render, staticRenderFns } from "./TeamStatistics.vue?vue&type=template&id=235f5557"
import script from "./TeamStatistics.vue?vue&type=script&lang=js"
export * from "./TeamStatistics.vue?vue&type=script&lang=js"
import style0 from "./TeamStatistics.vue?vue&type=style&index=0&id=235f5557&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235f5557')) {
      api.createRecord('235f5557', component.options)
    } else {
      api.reload('235f5557', component.options)
    }
    module.hot.accept("./TeamStatistics.vue?vue&type=template&id=235f5557", function () {
      api.rerender('235f5557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/TeamStatistics.vue"
export default component.exports